"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const discoverRoutes_1 = __importDefault(require("./discoverRoutes"));
exports.default = {
    Home: {
        screens: {
            ...discoverRoutes_1.default,
            Chats: 'Chats',
        },
    },
    OneToOneChat: 'Chats/:characterId',
    SummaryChat: 'Summary/Chat/:conversationId?/:shareId?/:autoMessage?',
    AddSources: 'AddSources',
};
